import { UserCircle } from 'lucide-react';
import AdminUserManagement from './AdminUserManagement';

export default function AdminClients() {
  return (
    <AdminUserManagement
      role="client"
      title="Clients"
      subtitle="Manage registered clients"
      Icon={UserCircle}
      emptyText="No clients found"
    />
  );
}
